import * as React from 'react';

const PickupPointBackground48 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.009 21.564C2.672 9.861 12.27 0 24 0c11.613 0 21.295 9.585 20.992 21.564-.22 8.716-5.917 16.368-13.989 19.251-.73.251-1.542 1.233-2.273 1.965-.8.8-1.523 1.667-2.245 2.477-.286.322-.56.634-.819.929-.405.461-.773.881-1.098 1.233-.228.247-.418.442-.568.581-.15-.14-.34-.334-.569-.581a75.448 75.448 0 0 1-1.098-1.233 167.94 167.94 0 0 0-.819-.929c-.721-.81-1.45-1.657-2.27-2.477-.716-.716-1.517-1.714-2.248-1.965-8.114-2.96-13.809-10.77-13.988-19.251Z"
  }
));
PickupPointBackground48.Size = 48;
PickupPointBackground48.Title = "PickupPointBackground";

export { PickupPointBackground48 as default };
